"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
// CSS
const styles_1 = tslib_1.__importDefault(require("./styles"));
const rangeStyles = { ...styles_1.default, ...{ root: { height: "auto", display: "flex", justifyContent: "center" } } };
const Range = (0, react_1.forwardRef)(({ classes = {}, min = 0, max = 1, step = 0.1, label, variant, classNames = "", value, ...rest }, ref) => {
    var _a;
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: rangeStyles }, "range");
    return (react_1.default.createElement("div", { className: mergedClasses.root },
        react_1.default.createElement("input", { type: "range", ref: ref, min: min, max: max, step: step, value: value, className: `${mergedClasses.range} ${classNames}`, "data-selenium": (_a = rest.tag) !== null && _a !== void 0 ? _a : "range-input", onInput: rest.onInput, onChange: rest.onChange, ...rest })));
});
exports.default = Range;
//# sourceMappingURL=Range.js.map